import KioskMain from '../components/KioskMain';
import MainOptions from '../components/MainOptions';
import MainOrderOptions from '../components/MainOrderOptions';
import KioskNumberLookup from '../components/KioskNumberLookup';
import PastOrdersInfo from '../components/PastOrdersInfo';
import KioskAuthForm from '../components/KioskAuthForm';
import KioskMenu from '../components/KioskMenu';
import KioskConfigurator from '../components/KioskConfigurator';
import KioskPayment from '../components/KioskPayment';
import KioskConfirmation from '../components/KioskConfirmation';
import KioskDiscount from '../components/KioskDiscount';
import KioskDiscountApply from '../components/KioskDiscountApply';
import KioskConfirmMessage from '../components/KioskConfirmMessage';
import KioskHelpMessage from '../components/KioskHelpMessage';
import KioskFriesMenu from '../components/KioskFriesMenu';
import KioskKidsMenu from '../components/KioskKidsMenu';
import KioskLazyMenu from '../components/KioskLazyMenu';

const routes = [
  {
    path:      '/',
    name:      'main',
    component: KioskMain,
  },
  {
    path:      '/options',
    name:      'kiosk-options',
    component: MainOptions,
  },
  {
    path:      '/number-lookup',
    name:      'number-lookup',
    component: KioskNumberLookup,
    props:     {
      title:       'Number Lookup',
      message:     'Enter the phone number you’ve used at a Burger Boss location to pull up past orders',
      buttonText:  'Learn More',
      buttonRoute: 'past-info',
    },
  },
  {
    path:      '/save-past-orders',
    name:      'save-past-orders',
    component: KioskNumberLookup,
    props:     {
      title:       'Save Past Orders',
      message:     'Enter a phone number to save this order for easy re-ordering in future visits! (OPTIONAL)',
      buttonText:  'Skip for now',
      buttonRoute: 'auth-form',
      savingPage:  true,
    },
  },
  {
    path:      '/menu',
    name:      'menu',
    component: KioskMenu,
  },
  {
    path:      '/order-options',
    name:      'kiosk-order-options',
    component: MainOrderOptions,
  },
  {
    path:      '/past-orders-info',
    name:      'past-info',
    component: PastOrdersInfo,
  },
  {
    path:      '/auth-form',
    name:      'auth-form',
    component: KioskAuthForm,
  },
  {
    path:      '/configurator/:id',
    name:      'configurator',
    component: KioskConfigurator,
  },
  {
    path:      '/payment',
    name:      'payment',
    component: KioskPayment,
  },
  {
    path:      '/confirmation',
    name:      'confirmation',
    component: KioskConfirmation,
  },
  {
    path:      '/discount',
    name:      'discount',
    component: KioskDiscount,
  },
  {
    path:      '/discount-apply',
    name:      'discount-apply',
    component: KioskDiscountApply,
  },
  {
    path:      '/confirm-message',
    name:      'confirm-message',
    component: KioskConfirmMessage,
  },
  {
    path:      '/help-message',
    name:      'help-message',
    component: KioskHelpMessage,
  },
  {
    path:      '/fries-menu',
    name:      'fries-menu',
    component: KioskFriesMenu,
  },
  {
    path:      '/kids-menu',
    name:      'kids-menu',
    component: KioskKidsMenu,
  },
  {
    path:      '/lazy-menu',
    name:      'lazy-menu',
    component: KioskLazyMenu,
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/apps/kiosk/router/index.js